import React from 'react';
import I18n from 'i18n-js';

import CoreLink from './core_link';
import { prefilledListingFromListing } from '../url_helpers';
import { MParticleEventName } from '../elog/mparticle_tracker';

import { buttonClassName } from '@reverbdotcom/commons/src/rc/RCButton/styling';

interface IProps {
  listingId?: string;
}

export function SellYoursButton({
  listingId,
}: IProps) {

  return (
    <CoreLink
      className={buttonClassName({ variant: 'primary', fullWidth: true })}
      to={prefilledListingFromListing(listingId)}
      target="_blank"
      clickEvent={{
        eventName: MParticleEventName.ClickedComponent,
        componentName: 'SellYoursButton',
        entityType: 'url',
        entityId: prefilledListingFromListing(listingId),
      }}
    >
      {I18n.t('commons.sellYoursButton')}
    </CoreLink>
  );
}
